$(function () {
  var cursor = $(".blog-cursor");

  function cursorInit() {
    // Track all pointer movements, including drag
    $(window).on("pointermove", function (e) {
      var offsetX = 10; 
      var offsetY = 10;
      cursor.css({
        top: e.clientY + offsetY,
        left: e.clientX + offsetX
      });
    });
  
    // Hide the cursor when leaving the swiper area
    $(".blogCursor").mouseleave(function () {
      cursor.css({
        opacity: "0",
        transform: "scale(0)"
      });
    }).mouseenter(function () {
      cursor.css({
        opacity: "1",
        transform: "scale(1)"
      });
    });
  }
  
  $(document).ready(function() {
    cursorInit();
  });
  
});